import { observer } from 'mobx-react-lite'
import React from 'react'
import { LINK_CALL_WHISPER } from 'shared/constants/links'
import { TextToSpeech } from 'widgets/TextToSpeech'
import { ToggleCard } from 'pages/settings/pages/inboxes/pages/id/pages/settings/calling/smart-call-flow/ui/SmartCallFlowBuilder/ui/actions/ForwardCall/ui/ForwardCallActionEditContent/NumberSetting/ToggleCard/ToggleCard'
import { type NumberWhisperStore } from './store/NumberWhisperStore'
import styles from './styles.module.scss'

export const NumberWhisper = observer(({ store }: { store: NumberWhisperStore }) => {
  const { active, setActive, textToSpeechWidgetStore } = store

  return (
    <>
      <ToggleCard
        title={'Call Whisper'}
        labelTooltip={
          <>
            Identify the call source <br /> before connecting.
            <br />
            <a href={LINK_CALL_WHISPER} target='_blank' rel='noreferrer'>
              Learn more
            </a>
          </>
        }
        description={'Plays a short message to the receiver before the call begins'}
        value={active}
        setValue={setActive}
      />
      {active && (
        <div className={styles.whisperSpeech}>
          <TextToSpeech
            title={''}
            isErrorNotReplaceVoice
            store={textToSpeechWidgetStore}
            actionsProps={{
              withMergeFields: true,
            }}
          />
        </div>
      )}
    </>
  )
})
